import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_DATE implements Validator {

    public static id = 'CTRL_DATE';
    private message = 'error.required';


    public LOG: LogService = new LogService(CTRL_DATE);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_DATE.id + '_');
        const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = ctrlMap.get(ctrl.value.rgCtrls.firstChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                if (firstChampCtrl.value.includes('yyyy-MM-dd')==false) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
